var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63983 1.62383V1C1.47013 1 1.30739 1.06572 1.1874 1.18272C1.06741 1.29971 1 1.45838 1 1.62383H1.63983ZM16.9957 1.62383H17.6355C17.6355 1.45838 17.5681 1.29971 17.4481 1.18272C17.3281 1.06572 17.1654 1 16.9957 1V1.62383ZM1.63983 2.24766H16.9957V1H1.63983V2.24766ZM16.3559 1.62383V11.6051H17.6355V1.62383H16.3559ZM15.2895 12.6449H3.34603V13.8925H15.2895V12.6449ZM2.27965 11.6051V1.62383H1V11.6051H2.27965ZM3.34603 12.6449C2.75739 12.6449 2.27965 12.1791 2.27965 11.6051H1C1 12.2118 1.24717 12.7936 1.68714 13.2226C2.1271 13.6515 2.72383 13.8925 3.34603 13.8925V12.6449ZM16.3559 11.6051C16.3559 12.1791 15.8781 12.6449 15.2895 12.6449V13.8925C15.9117 13.8925 16.5084 13.6515 16.9484 13.2226C17.3883 12.7936 17.6355 12.2118 17.6355 11.6051H16.3559Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64062 1.62402L9.31855 9.11L16.9965 1.62402",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64062 1.62402L9.31855 9.11L16.9965 1.62402",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.19732ba2360e75715b4fe84be377e809.svg";
export { ForwardRef as ReactComponent };